/**
 * Toggle Code Sandbox entry in academy navigation and /code-sandbox routes.
 * Set to true when the feature is ready to ship.
 */
export const IS_CODE_SANDBOX_ENABLED = false
